import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import TripRateDay from "../ViewModels/TripRateDay";

interface IProps {
    arrivalRow: TripRateDay;
    departureRow: TripRateDay;
    totalRow: TripRateDay;
    period: string;
    peakPeriodArrivals: string;
    peakPeriodDepartures: string;
    peakPeriodTotals: string;
    extrapolate: boolean;
    extrapolateValue?: number;
}

const round3 = (n: number) => Math.round((n + Number.EPSILON) * 1000) / 1000;
const fmt3 = (n: number) => round3(n).toFixed(3);
const est = (pre?: number | null, k?: number | null) => (pre == null || k == null ? null : round3(pre * k));

export default function TripRateTableRow({
    arrivalRow,
    departureRow,
    totalRow,
    period,
    peakPeriodArrivals,
    peakPeriodDepartures,
    peakPeriodTotals,
    extrapolate,
    extrapolateValue
}: IProps) {
    const estArr = est(arrivalRow.tripRatePreCalculation, extrapolateValue);
    const estDep = est(departureRow.tripRatePreCalculation, extrapolateValue);
    const estTotal = estArr == null || estDep == null ? null : round3(estArr + estDep);

    return (
        <TableRow>
            <TableCell>
                <Typography>{period}</Typography>
            </TableCell>

            {arrivalRow.numberOfDays != null ? (
                <>
                    <TableCell>
                        <Typography>{arrivalRow.numberOfDays}</Typography>
                    </TableCell>

                    <TableCell>
                        <Typography>
                            {arrivalRow.averageParameter != null
                                ? Math.abs(arrivalRow.averageParameter) >= 1
                                    ? Math.round(arrivalRow.averageParameter).toString()
                                    : arrivalRow.averageParameter.toFixed(2)
                                : ""}
                        </Typography>
                    </TableCell>

                    <TableCell sx={{ backgroundColor: peakPeriodArrivals === period ? "yellow" : "transparent" }}>
                        <Typography>{arrivalRow.tripRate != null ? fmt3(arrivalRow.tripRate) : ""}</Typography>
                    </TableCell>

                    {extrapolate && (
                        <TableCell style={{ backgroundColor: '#F5F5DC' }}>
                            <Typography>{estArr == null ? "" : fmt3(estArr)}</Typography>
                        </TableCell>
                    )}

                    <TableCell sx={{ backgroundColor: peakPeriodDepartures === period ? "yellow" : "transparent" }}>
                        <Typography>{departureRow.tripRate != null ? fmt3(departureRow.tripRate) : ""}</Typography>
                    </TableCell>

                    {extrapolate && (
                        <TableCell style={{ backgroundColor: '#F5F5DC' }}>
                            <Typography>{estDep == null ? "" : fmt3(estDep)}</Typography>
                        </TableCell>
                    )}

                    <TableCell sx={{ backgroundColor: peakPeriodTotals === period ? "yellow" : "transparent" }}>
                        <Typography>{totalRow.tripRate != null ? fmt3(totalRow.tripRate) : ""}</Typography>
                    </TableCell>

                    {extrapolate && (
                        <TableCell style={{ backgroundColor: '#F5F5DC' }}>
                            <Typography>{estTotal == null ? "" : fmt3(estTotal)}</Typography>
                        </TableCell>
                    )}
                </>
            ) : (
                <TableCell colSpan={extrapolate ? 8 : 5}>
                    <Typography>No data available for this period</Typography>
                </TableCell>
            )}
        </TableRow>
    );
}
